import { types } from "../types/types";


const initialState={
    in_process: [],
    list: [],
    total: 0,
    loading: false
}



export const paymentReducer=(state=initialState,action)=>{
    switch (action.type) {
        case types.paymentsloading:
            return {
                ...state,
                list: action.payload.pagos,
                in_process: action.payload.in_process,
                total: action.payload.total
            }
        case types.paymentsStartLoading:
            return {
                ...state,
                loading: true
            }
        case types.paymentsFinishLoading:
            return {
                ...state,
                loading: false
            }
        case types.paymentsAddPayment:
            return {
                ...state,
                [action.payload.type]: [
                    ...state.[action.payload.type],
                    action.payload.payment
                ]
            }
        case types.paymentsAddTotal:
            return {
                ...state,
                total: parseInt(state.total) + parseInt(action.payload)
            }
        case types.paymentsLogout:
            return initialState;
        default:
            return state;
    }
}